module.exports = __webpack_public_path__ + "fonts/capsule_nes.svg?v=4c4dd3d531bc204da4742372b918ae88";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/capsule_nes.svg
// module id = 689
// module chunks = 0